import { IAntDProTableRequest } from "../../../general/type/general.types";
import { apiRequest, downloadFile } from "../../../services/api";
import { openOrDownloadBlob } from "../../../utils/fileDownload";
import { IPayslipRequest, IApiResponseGetPayslips } from "../type/payslip";

export const getPayslips = async (
  tableRequest: IAntDProTableRequest
): Promise<IApiResponseGetPayslips> => {
  const response = await apiRequest("GET", "/payslips", tableRequest);
  return response.data;
};

export const getUserPayslips = async (
  userId: string,
  tableRequest: IAntDProTableRequest
): Promise<IApiResponseGetPayslips> => {
  const response = await apiRequest(
    "GET",
    `/payslips/user-payslips/${userId}`,
    tableRequest
  );
  return response.data;
};

export const createPayslip = async (data: IPayslipRequest) => {
  const response = await apiRequest<IPayslipRequest>("POST", "/payslips", data);
  return response.data;
};

export const getPayslipById = async (id: string | undefined) => {
  const response = await apiRequest<IApiResponseGetPayslips>(
    "GET",
    `/payslips/${id}`
  );
  return response.data;
};

export const editPayslip = async (id: string, data: IPayslipRequest) => {
  const response = await apiRequest<IPayslipRequest>(
    "PATCH",
    `/payslips/${id}`,
    data
  );
  return response.data;
};

export const archivePayslip = async (id: string) => {
  const response = await apiRequest("PATCH", `/payslips/${id}/archive`);
  return response.data;
};

export const downloadPayslipFileFromS3 = async (
  payslipId: string,
  relativePath: string
) => {
  try {
    const blob = await downloadFile(
      `/payslips/${payslipId}/download?filePath=${encodeURIComponent(
        relativePath
      )}`
    );
    const fileName = relativePath.split("/").pop() || "downloaded-file";
    openOrDownloadBlob(blob, fileName);
    return true;
  } catch (error) {
    console.error("Error downloading file:", error);
    throw error;
  }
};
